export default __webpack_public_path__ + "static/media/his3.e8f8a0cb.jpg";